import React from "react";

const PartnersIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="24"
      height="14"
      viewBox="0 0 24 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 13.2363C10.0899 13.2363 13 10.3262 13 6.73633C13 3.14648 10.0899 0.236328 6.5 0.236328C2.91015 0.236328 0 3.14648 0 6.73633C0 10.3262 2.91015 13.2363 6.5 13.2363Z"
        fill="#50E3C2"
      />
      <path
        d="M16.8984 13.2363C20.4883 13.2363 23.3984 10.3262 23.3984 6.73633C23.3984 3.14648 20.4883 0.236328 16.8984 0.236328C13.3086 0.236328 10.3984 3.14648 10.3984 6.73633C10.3984 10.3262 13.3086 13.2363 16.8984 13.2363Z"
        fill="#50E3C2"
      />
      <path d="M6.5 6.73633H16.9" stroke="white" stroke-width="1.95" />
    </svg>
  );
};

export default PartnersIcon;
